fragment NotifyTimeFields on NotifyTime {
  id
  notifyTypeId
  notifyType {
    description
    hint
  }
  timeZoneId
  timeZone {
    standardTimeZoneCode
  }
  sortOrder
  isSentMonday
  isSentTuesday
  isSentWednesday
  isSentThursday
  isSentFriday
  isSentSaturday
  isSentSunday
  startSendTime
  endSendTime
  lastRun
  _isUpdatable
  _isDeletable
  _rowTimestamp
}
